import { useEffect } from 'react';

type Callback = () => void;

export const useTabFocus = ({ onFocus, onFocusLost }: { onFocus?: Callback; onFocusLost?: Callback }): void => {
  let listener: any = null;

  const setupListener = (): (() => void) => {
    listener = document.addEventListener('visibilitychange', (e: { target: any }) => {
      if (e.target?.visibilityState === 'visible') {
        onFocus?.();
      }

      if (e.target?.visibilityState === 'hidden') {
        onFocusLost?.();
      }
    });

    return () => {
      listener && document.removeEventListener('visibilitychange', listener);
    };
  };

  useEffect(() => {
    const cleanUp = setupListener();

    return cleanUp();
  }, []);
};
